import Vue from 'vue';
import WorkDividedInBase from '@/components/global_components/layout/WorkDividedInBase';
import WorkDividedInColumnDivider from '@/components/global_components/layout/WorkDividedInColumnDivider';
import WorkDividedInWrapperRow from '@/components/global_components/layout/WorkDividedInWrapperRow';
import WorkDividedInContentWrapperColumn from '@/components/global_components/layout/WorkDividedInContentWrapperColumn';
import WorkDividedInContentWrapperExpandableColumn
  from '@/components/global_components/layout/WorkDividedInContentWrapperExpandableColumn';
import WorkInlineTitle from '@/components/global_components/layout/WorkInlineTitle';
import WorkAddressReadonlyLayout from '@/components/global_components/layout/readonly/WorkAddressReadonlyLayout';
import WorkContactReadonlyLayout from '@/components/global_components/layout/readonly/WorkContactReadonlyLayout';
import WorkCard from '@/components/base_components/layout/WorkCard';

Vue.component('WCard', WorkCard);

Vue.component('WDividedIn', WorkDividedInBase);
Vue.component('WDividedInDivider', WorkDividedInColumnDivider);
Vue.component('WDividedInDividerLayoutWrapper', WorkDividedInWrapperRow);
Vue.component('WDividedInContentWrapper', WorkDividedInContentWrapperColumn);
Vue.component('WDividedInContentWrapperExpandable', WorkDividedInContentWrapperExpandableColumn);

Vue.component('WInlineTitle', WorkInlineTitle);
Vue.component('WAddressReadonly', WorkAddressReadonlyLayout);
Vue.component('WContactReadonly', WorkContactReadonlyLayout);
